import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';
import { initYaCaptcha, YA_CAPTCHA_ENABLED } from '../../tools/functions';
import { leadGoal } from '../../services/analytics/analytics';


export const CallbackModal = {
    props: {
        structKey: [String, Number]
    },
    data(){
        return {
          captcha: false,
          yatoken: ''
        }
      },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH', 'YA_CLIENT_KEY', 'captchaInited', 'templateData'])
    },
    methods: {
        execCaptcha(){
            vplSiteStore.capresolved = true;
            this.sendForm();
        },
        sendForm(){
            let form = $(this.$el).find('form'),
                data = {};

            $.each($("input,textarea,button,select", form), function () {
                if ($(this).attr("type") == "checkbox") {
                    if ($(this).prop("checked")) {
                        data[$(this).attr("name")] = true;
                    }
                } else if ($(this).attr("type") == "radio") {
                    if ($(this).prop("checked")) {
                        data[$(this).attr("name")] = ($(this).hasClass("js-phone") ? $(this).val().replace(/\D/g, "") : $(this).val());
                    }
                } else if (
                    $(this).attr("name") !== undefined &&
                    $(this).attr("name").length
                ) {
                    data[$(this).attr("name")] = ($(this).hasClass("js-phone") ? $(this).val().replace(/\D/g, "") : $(this).val());
                }
            });

            data['WEB_FORM_ID'] = 6;
            data['web_form_submit'] = 'y';
            data['sessid'] = BX.bitrix_sessid();
            data['url'] = window.location.href;

            data['smart-token'] = this.yatoken;

            if(vplSiteStore.capresolved){
                data['skip-captcha'] = 'Y';
            }

            $.ajax({
                url: '/ajax/form.php',
                method: 'POST',
                data: data,
                success: (response) => {
                    form.find(".is-error").removeClass("is-error");
                    response = JSON.parse(response);

                    if (!response.ERRORS || !Object.keys(response.ERRORS).includes("CAPTCHA")) {
                        vplSiteStore.capresolved = true;
                    }

                    if (response.STATUS == "OK") {
                        leadGoal('callback', response);
                        form.find("input[type=text],input[type=email],textarea").val("");

                        if (form.closest(".modal").length) {
                            form.closest(".modal").modal("hide");
                        }

                        $('#success').modal();

                    } else {
                        for (var i in response.ERRORS) {
                            if (i == "CAPTCHA") {
                                form.find(".captcha").addClass("is-error");
                            } else {
                                form
                                    .find("[name=" + i + "]")
                                    .parent()
                                    .addClass("is-error");
                            }
                        }
                    }
                }
            });
        },
        initCaptcha(){

          let self = this;

          initYaCaptcha();

          let interval = setInterval(()=>{
            if(this.captcha === false &&  (!YA_CAPTCHA_ENABLED || typeof window.smartCaptcha !== "undefined") && this.YA_CLIENT_KEY){


              this.captcha = YA_CAPTCHA_ENABLED && window.smartCaptcha.render($(this.$el).find('.js-captcha')[0], {
                  sitekey: self.YA_CLIENT_KEY,
                  invisible: true,
                  callback: function(token) {
                      window.yaToken = token;
                      self.yatoken = token;
                      self.sendForm();
                  },
                  hideShield: true,
              });

              // SAIT-131: телефон форматирует общий tasApplyPhoneInputMask.

              clearInterval(interval);
            }
          }, 500);
        }
    },
    updated(){


    },
    mounted(){

      let self = this;
      if(self.captchaInited){
        self.initCaptcha();
      }else{
        const elem = self.$el;
        new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    self.initCaptcha();
                    observer.unobserve(entry.target);
                }
            });
        }).observe(elem);
      }

    },
    template: `
<div class="modal fade modal-fastbuy modal-order hide" id="callback"  tabindex="-1" style="display: none;" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title">Заказать звонок</div>
          <button aria-label="Закрыть" type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">
                <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
              </span>
          </button>
      </div>
      <div class="modal-body">
        <form action="" @submit.prevent="execCaptcha()">
            <div class="field js-material-input is-required" :class="{active: templateData.userName}">
              <input class="field__input" name="form_text_37" id="callback-name" autocomplete="off" type="text" :value="templateData.userName">
              <label class="field__label" for="callback-name">Имя</label>
              <span class="field__error-text">Заполнено некорректно.</span>
            </div>
            <div class="field js-material-input is-required field--callback-phone" :class="{active: templateData.userPhone}">
              <input class="field__input js-phone" name="form_text_38" id="callback-tel" autocomplete="off" type="text"  :value="templateData.userPhone">
              <label class="field__label" for="callback-tel">Телефон</label>
              <span class="field__error-text">Заполнено некорректно.</span>
            </div>
            <div class="field js-material-input is-required">
              <textarea class="field__input field__input--textarea" rows="3" name="form_textarea_39" id="callback-text" placeholder="Ваше сообщение" autocomplete="off"></textarea>
              <span class="field__error-text">Заполнено некорректно.</span>
            </div>
            <div class="form__submit">
              <div class="form__submit-container">
                <div class="captcha">
                  <div class="captcha js-captcha">
                  </div>
                </div>
                    <button type="submit" class="btn btn--green">
                       Отправить
                    </button>
              </div>
              <div class="checkbox">
                <input type="checkbox" name="politic" checked class="checkbox__input js-politic js-politic-auto" id="politic-callback">
                <label for="politic-callback" class="checkbox__label">
                  При нажатии на кнопку «Отправить» вы соглашаетесь с <a href="/politika-konfidentsialnosti/" target="_blank">условиями о сборе персональных данных</a>
                </label>
              </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
      `
}